import type { PortfolioListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	RETIREMENT_LOAN_DOMAINS,
	RETIREMENT_SAVING_DOMAINS,
} from "web_myplann/Inspiration/Retirement/constants";
import type { RetirementRelevantPortfolioItem } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

export const isRetirementRelevantPortfolioItem = (
	item: PortfolioListItemResponseDTO,
): item is RetirementRelevantPortfolioItem =>
	!item.archived &&
	!!item.domain &&
	(RETIREMENT_LOAN_DOMAINS.has(item.domain) ||
		RETIREMENT_SAVING_DOMAINS.has(item.domain));
